<template>
	<div class="downloadApp">

		<div class="imgList">
			<img src="@/assets/app1.jpg" alt="" />
			<img src="@/assets/app2.jpg" alt="" />
			<img src="@/assets/app3.jpg" alt="" />
			<img src="@/assets/app4.png" alt="" />
		</div>
		<div class="downloadBtn" @click="getApk">下载APP</div>
		<p>
			云红药之家药店是经国家药品监督等行业主管部门批准的正规药品采购、销售、网上药品交易电子商务平台。网址：www.yaozj.shop。
		</p>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				apiUrl: "http://ynyh-image.ynoss.xstore.ctyun.cn/app/app.apk",
			};
		},
		methods: {
			getApk() {
				window.open('https://ynyh-image.ynoss.xstore.ctyun.cn/app/app.apk', '_self');
			},
		},
	};
</script>

<style lang="scss" scoped>
	.downloadApp {
		width: 1200px;
		margin: 0 auto;
		padding-top: 50px;

		.downloadBtn {
			text-align: center;
			width: 100px;
			height: 40px;
			line-height: 40px;
			cursor: pointer;
			background-color: red;
			color: #fff;
			font-size: 14px;
			margin: 0 auto;
			margin-top: 20px;
		}

		.imgList {
			width: 100%;
			display: flex;
			justify-content: space-between;

			img {
				width: 300px;
				height: auto;
			}
		}

		p {
			text-align: left;
			text-indent: 2em;
			font-size: 18px;
		}
	}
</style>
